import { toast } from "react-toastify";


function ToastMessage({cod, texto})
{
    
    const padrao = ()=>{
        //definição da estilização do toast
        return({position:"top-right",
            autoClose: 5000, // Fecha automaticamente após 5 segundos
            hideProgressBar: false,            
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,})
    }
    //cenários de utilização
    switch(cod)
    {
        case "s":
            toast.success(texto, padrao());
        break;
            
        case "e":
            toast.error(texto, padrao());
        break;

        case "w":
            toast.warning(texto, padrao());
        break;
        
        case "i":
            toast.info(texto, padrao());
        break;

        default:
            toast.info(texto, padrao());

        
    }
    
    
}

export default ToastMessage;